import React from 'react';
import colors from '@styles/colors';
import OutdoorsSVG from '../SvgIcons/OutdoorsSVG';
import { SpRoundIcon } from './SpRoundIcon';

interface SpTreesIconProps {
  action?: any;
  size?: number;
  iconSize?: number;
}

export const SpTreesIcon = ({ action, size = 12, iconSize = 21 }: SpTreesIconProps) => (
  <SpRoundIcon
    icon={
      <OutdoorsSVG
        color={colors.greyText.color}
        width={iconSize}
        height={iconSize}
        viewBox="0 0 17 17"
      />
    }
    action={action}
    size={size}
    color={colors.secondary2.color}
    componentName="SpTreesIcon"
  />
);
